/**
 * Événement DOM émis après consommation réussie d'un crédit de quota invité
 * (guest_quotas). Permet à useQuota (badge/gate) de se rafraîchir dans la
 * même session sans reload, sans coupler directement useAutoSave et useQuota.
 *
 * Cf. correctif du 10/09/2026 : useQuota ne relisait le quota invité qu'au
 * montage, donc un invité créant 3 conversations dans la même session sans
 * recharger la page ne voyait jamais le garde-fou se déclencher avant la 4e.
 */
export const GUEST_QUOTA_UPDATED_EVENT = "doodates:guest-quota-updated";

export function notifyGuestQuotaUpdated(): void {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(GUEST_QUOTA_UPDATED_EVENT));
  }
}
